import ArticleLayout from '@/components/feature/ArticleLayout';
import { articlesBySlug } from '@/mocks/articles';

export default function KakobuyStreetwearPoradnik() {
  return <ArticleLayout article={articlesBySlug['kakobuy-streetwear-poradnik']} />;
}